import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { babyShowerFaq } from '../../data/babyShowerFaq';
const faqCopy = {
  eyebrow: 'Resolvemos tus dudas',
  title: 'Preguntas frecuentes'
};
export function FaqList() {
  const [open, setOpen] = useState<number | null>(null);
  const reduce = useReducedMotion();
  return <section aria-labelledby="faq-title" className="bg-[#FBF6EE] py-11 md:py-16" data-id="element-96" data-mp="16wfjt9beijlk">
      <div className="mx-auto max-w-2xl px-5" data-id="element-97" data-mp="1ayatp27ee5ay">
        <header className="text-center" data-id="element-98" data-mp="1b15cyqeodk2s">
          <p className="inline-flex max-w-full items-center rounded-full border border-[#EADFCF] bg-white px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.08em] text-[#8B6B55] sm:text-[12px]" data-id="element-99" data-mp="1fxng5lucxad0">
            {faqCopy.eyebrow}
          </p>
          <h2 id="faq-title" className="mt-4 font-display text-[1.65rem] font-extrabold leading-[1.15] tracking-[-0.02em] text-[#4A3A35] sm:text-[2.1rem] md:text-[2.4rem]" data-id="element-100" data-mp="3hrcvm2zr6qc3">
            {faqCopy.title}
          </h2>
        </header>

        <ul className="mt-7 space-y-2.5 md:mt-9 md:space-y-3" data-id="element-101" data-mp="2hu5ay4v9u3pj">
          {babyShowerFaq.map((item, i) => {
          const isOpen = open === i;
          const Icon = isOpen ? MinusIcon : PlusIcon;
          return <li key={item.question} className={`rounded-2xl border bg-white transition-colors duration-200 ease-out ${isOpen ? 'border-[#F5B4C9]' : 'border-[#EFE4D6]'}`} data-id="element-102" data-mp="28wcuuyhq6s13" data-mpi={i}>
                <h3 data-id="element-103" data-mp="2wjkwn6fy3iyd">
                  <button type="button" id={`faq-q-${i}`} aria-expanded={isOpen} aria-controls={`faq-a-${i}`} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 rounded-2xl px-4 py-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-[#E74D7A] sm:px-5" data-id="element-104" data-mp="2wirpi4d2qrfp">
                    <span className="text-[16px] font-bold leading-snug text-[#4A3A35] sm:text-[17px]" data-id="element-105" data-mp="1mlumi5jffvm8">{item.question}</span>
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors duration-200 ease-out ${isOpen ? 'bg-[#FDE3EC] text-[#E74D7A]' : 'bg-[#DDF2F1] text-[#15ADA8]'}`} aria-hidden="true" data-id="element-106" data-mp="18la4hblc63ts">
                      <Icon className="h-4 w-4" strokeWidth={2.25} data-id="element-107" data-mp="13p1vkfxqf6v2" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-108" data-mp="twns9ir09s6s">
                  {isOpen && <motion.div id={`faq-a-${i}`} role="region" aria-labelledby={`faq-q-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: reduce ? 0 : 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-109" data-mp="fxwc7qsl1wg0">
                      <p className="px-4 pb-4 text-[16px] leading-relaxed text-body sm:px-5 sm:pb-5" data-id="element-110" data-mp="69it6ij4ss0t">{item.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}